module.exports = __webpack_public_path__ + "img/Pack-cardio.e5be9f45.jpg";